import { render, staticRenderFns } from "./SimpleChipWithTitle.vue?vue&type=template&id=e33408b2&"
import script from "./SimpleChipWithTitle.vue?vue&type=script&lang=ts&"
export * from "./SimpleChipWithTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports